module.exports = __webpack_public_path__ + "static/media/ta-da@2x.9714a42b.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/doodles/ta-da@2x.png
 ** module id = 2000
 ** module chunks = 50
 **/